import { Heart, Baby, Users, Sparkles, Flower2, Award, CalendarCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { serviceCategories, JANE_BOOKING_URL } from '../data/janeServices';

const CATEGORY_ICONS = {
  'pelvic-health-wellness': Heart,
  'pregnancy-birth-postpartum': Baby,
  'childbirth-education-cpr': Users,
  'lactation-consulting': Sparkles,
  'perimenopause-menopause': Flower2,
  'maternity-concierge': Award
};

const ServicesPage = () => {
  return (
    <div data-testid="services-page" className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="pt-24 pb-12 md:pt-28 md:pb-14 bg-muted">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center max-w-3xl mx-auto space-y-6">
            <p className="text-sm tracking-widest uppercase font-semibold text-primary">
              Our Services
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-foreground">
              How We Can Help
            </h1>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Personalized support for women at every stage of life.
            </p>
          </div>
        </div>
      </section>

      {/* Service Categories */}
      <section data-testid="service-categories" className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {serviceCategories.map((category) => {
              const Icon = CATEGORY_ICONS[category.id];
              return (
                <div
                  key={category.id}
                  id={category.id}
                  data-testid={`service-category-${category.id}`}
                  className="bg-white p-8 rounded-3xl border border-border/50 shadow-sm hover:shadow-lg transition-shadow duration-500 scroll-mt-28"
                >
                  <div className="w-16 h-16 bg-secondary/20 rounded-2xl flex items-center justify-center mb-6">
                    <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <h2 className="text-2xl font-medium text-foreground mb-3">
                    {category.title}
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {category.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Book Online */}
          <div className="text-center mt-16">
            <a
              href={JANE_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-book-online-button"
            >
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 px-10 py-6 rounded-full text-base font-medium transition-transform hover:-translate-y-1 shadow-lg">
                <CalendarCheck className="w-5 h-5 mr-2" />
                Book Online
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
